import { render, staticRenderFns } from "./WhiteboardControl.vue?vue&type=template&id=63a04dd6&scoped=true"
import script from "./WhiteboardControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./WhiteboardControl.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a04dd6",
  null
  
)

export default component.exports